import { io } from "socket.io-client";
import Cookies from "js-cookie";
const URL = 'https://api.homedotapp.com';
const token = Cookies.get("a_token");

const socket = io(URL, {
  // transports: ["websocket"],
  // upgrade: false,
  autoConnect: false,
  query: {
    token: token,
  },
});

socket.onAny((event, ...args) => {
  console.log(event, args);
});
export default socket;
